import Claims from "../molecules/Claims";

const ClaimSummary = () => (
    <>
        <Claims onlyRecent={false}/>
    </>
);
export default ClaimSummary;
